import { useQuery } from 'convex/react';

import { api } from '@/convex/_generated/api';

export function useUser() {
  // Get user information from authentication
  const user = useQuery(api.user.getUser);

  return {
    email: user?.email || null,
    name: user?.name || (user?.email ? user.email.split('@')[0] : 'User'),
    id: user?._id || null,
  };
}
